import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/GCOIN.png'
import _imports_1 from '../../assets/ggm_icon.png'


const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center space-x-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-10"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-white font-semibold" }, "GCoin")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "(Monster Galaxy)")
  ])
], -1)
const _hoisted_4 = { class: "flex justify-center items-center" }
const _hoisted_5 = {
  class: "text-sm",
  style: {"color":"#01bd35"}
}
const _hoisted_6 = { class: "flex flex-col space-y-2" }
const _hoisted_7 = { class: "flex space-x-1 ggm-menu font-semibold" }
const _hoisted_8 = { class: "flex flex-col space-y-4" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center space-x-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-10"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-white font-semibold" }, "GGM")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "(Monster Galaxy)")
  ])
], -1)
const _hoisted_11 = { class: "flex justify-center items-center" }
const _hoisted_12 = {
  class: "text-sm",
  style: {"color":"#01bd35"}
}
const _hoisted_13 = { class: "flex flex-col space-y-2" }
const _hoisted_14 = { class: "flex space-x-1 ggm-menu font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      loading: _ctx.loading,
      class: "gcoin-card text-white"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, "Balance: " + _toDisplayString(_ctx.balanceFormat(_ctx.balanceInfo?.account?.assets[0]?.amount)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isMe)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "rounded px-5 py-1 bg-[#01BD35] text-white",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSendToClick(0)))
                  }, "Send"))
                : _createCommentVNode("", true),
              (_ctx.isMe)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    class: "rounded px-5 py-1 bg-[#9C83C7] text-white",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCrossChainClick(2)))
                  }, "Bridge"))
                : _createCommentVNode("", true),
              (_ctx.isMe)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: "/trade",
                    href: "#",
                    class: "rounded px-5 py-1 bg-[#FED752] text-white",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCrossChainClick('trade')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Trade ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_a_card, {
      loading: _ctx.loading,
      class: "gcoin-card"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, "Balance: " + _toDisplayString(_ctx.balanceFormat(_ctx.balanceInfo?.account?.assets[1]?.amount)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.isMe)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "rounded px-5 py-1 bg-[#01BD35] text-white",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSendToClick(1)))
                  }, "Send"))
                : _createCommentVNode("", true),
              (_ctx.isMe)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    class: "rounded px-5 py-1 bg-[#9C83C7] text-white",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleCrossChainClick(2)))
                  }, "Bridge"))
                : _createCommentVNode("", true),
              (_ctx.isMe)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: "/trade",
                    href: "#",
                    class: "rounded px-5 py-1 bg-[#FED752] text-white",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleCrossChainClick('trade')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Trade ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ], 64))
}